import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function loadDateAutoInitRule(params) {
  return request({
    url: URL.mdm.loadDateAutoInitRule,
    method: 'get',
    params
  })
}
